import React, {useState} from "react";
import {Header, StyledButton, StyledCard, StyledForm, StyledTextField, Subtext,} from "./RequestPasswordReset.styled";
import Logo from "../../assets/images/taia_logo.png";
import {AuthContainer} from "./Auth.styled";
import axios from "axios";
import LogoWithLanguageSwitcher from '../../components/common/LogoWithLanguageSwitcher';
import {useNavigate} from "react-router-dom";
import {useSnackbar} from "../../contexts/SnackbarContext";
import {usePageTitle} from '../../hooks/usePageTitle';
import {PageTitleKeys} from '../../config/routeConstants';
import {CircularProgress} from '@mui/material';
import {parseError} from "../../services/http.service";
import {useTranslation} from 'react-i18next';

const RequestPasswordReset: React.FC = () => {
    usePageTitle(PageTitleKeys.RequestPasswordReset);
    const {t} = useTranslation();
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();

    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            await axios.post(`/auth/password-reset-request`, {
                email,
            });
            showSnackbar(t('requestPasswordReset.successMessage'), 'success');
            navigate("/check-mailbox");
        } catch (error) {
            console.error("Błąd resetowania hasła:", error);
            showSnackbar(parseError(error), "error");
            return false;
        }
        setIsLoading(false);
    };

    return (
        <AuthContainer role="region" aria-labelledby="request-password-reset-title">
            <LogoWithLanguageSwitcher src={Logo} alt={t('auth.logo.alt')} clickable={true} />
            <StyledCard>
                <Header id="request-password-reset-title">{t('requestPasswordReset.title')}</Header>
                <Subtext>{t('requestPasswordReset.subtitle')}</Subtext>
                <StyledForm autoComplete="off" aria-live="polite" aria-atomic={true} aria-busy={isLoading}>
                    <div>
                        <StyledTextField
                            label={t('requestPasswordReset.email')}
                            value={email}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                            fullWidth
                            disabled={isLoading}
                            inputProps={{ 'aria-label': t('requestPasswordReset.email.ariaLabel') as string }}
                        />
                        <div style={{ height: '24px', marginTop: '4px' }}></div>
                    </div>
                    {isLoading && (
                        <div role="status" aria-live="polite" style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(1px, 1px, 1px, 1px)' }}>
                            {t('requestPasswordReset.loading')}
                        </div>
                    )}
                    <StyledButton onClick={handleSubmit} disabled={isLoading || !email} aria-label={t('requestPasswordReset.sendButton.ariaLabel') as string}>
                        {isLoading ? <CircularProgress size={24} sx={{color: 'inherit'}}/> : t('requestPasswordReset.sendButton')}
                    </StyledButton>
                </StyledForm>
            </StyledCard>
        </AuthContainer>
    );
};

export default RequestPasswordReset;
